(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//== FONE MASK ==//

var FoneMask = function FoneMask() {
  _classCallCheck(this, FoneMask);

  var SPMaskBehavior = function SPMaskBehavior(val) {
    return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
  },
      spOptions = {
    onKeyPress: function onKeyPress(val, e, field, options) {
      field.mask(SPMaskBehavior.apply({}, arguments), options);
    }
  };

  $('.form--input[type="tel"]').mask(SPMaskBehavior, spOptions);
};

exports.default = FoneMask;

},{}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//== MOBILE ==//

var MobileMenu = function MobileMenu() {
  _classCallCheck(this, MobileMenu);

  $(document).on({
    'touchstart': function touchstart(e) {
      if (!($('.header--menu').is(e.target) || $('.header--menu-block').is(e.target) || $('.header--menu-block a').is(e.target))) {
        $('.header').removeClass('mobile-bg');
        $('.header--menu').removeClass('mobile');
      }

      if ($('.header--hamburger .fa-bars').is(e.target)) {
        $('.header').addClass('mobile-bg');
        $('.header--menu').addClass('mobile');
      }
    },

    'touchend': function touchend(e) {
      if ($('.header--menu-block a').is(e.target)) {
        $('.header').removeClass('mobile-bg');
        $('.header--menu').removeClass('mobile');
      }
    }
  });
};

exports.default = MobileMenu;

},{}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//== FORM MODAL ==//

var Modal = function Modal() {
  _classCallCheck(this, Modal);

  var classSVGEmpresas = $('.empresas--logos > svg').toArray();

  $(classSVGEmpresas).each(function (e) {
    var classID = $(classSVGEmpresas[e]);

    $(classID).on({
      'click': function click(event) {
        event.preventDefault();
        $(this).next().show();
      }
    });

    // if (classID) {
    //   classDest[e] = classID;


    // }
  });

  // console.log(classSVGEmpresas);

  // $('.empresas--logos > svg').on({
  //   'click': function (event) {
  //     event.preventDefault();

  //     $('.empresas--content').show();
  //   }
  // });

  $('.empresas--content-close').on({
    'click': function click(event) {
      event.preventDefault();
      $('.empresas--content').hide();
    }
  });
};

exports.default = Modal;

},{}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//== SCROLL TO ==//

var ScrollTo = function ScrollTo() {
  _classCallCheck(this, ScrollTo);

  $(".home .header--logo-anchor").on({
    click: function click(event) {
      event.preventDefault();

      $('html, body').animate({ scrollTop: 0 }, 1000);
    }
  });

  var linkArrayTop = $('.home .header--menu a').toArray();

  $(linkArrayTop).each(function (e) {
    var linkDest = [];
    var linkId = $(linkArrayTop[e]).attr('href');

    // console.log(linkId);

    if (linkId) {
      linkDest[e] = linkId;

      $(linkArrayTop[e]).on({
        click: function click(event) {
          //event.preventDefault();
          $('html, body').animate({
            scrollTop: $(linkDest[e]).offset().top - 80
          }, 1000);
        }
      });
    }
  });

  // var linkArrayBottom = $('.home .header--bottom a').toArray();

  // $(linkArrayBottom).each(function (e) {
  //   var linkDest = [];
  //   var linkId = $(linkArrayBottom[e]).attr('href');

  //   if (linkId) {
  //     linkDest[e] = linkId;

  //     $(linkArrayBottom[e]).on({
  //       click: function (event) {
  //         event.preventDefault();
  //         $('html, body').animate({
  //           scrollTop: $(linkDest[e]).offset().top - 80
  //         }, 1000);
  //       }
  //     });
  //   }
  // });
};

exports.default = ScrollTo;

},{}],5:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//== STICKY HEADER ==//

var StickyHeader = function StickyHeader() {
  _classCallCheck(this, StickyHeader);

  $(window).scroll(function () {
    if (!$('body').hasClass('single') && !$('body').hasClass('page')) {
      if ($(this).scrollTop() > 150) {
        $('.header--top').addClass('sticky');
        // $('.banner').addClass('margin-top');
      } else {
        $('.header--top').removeClass('sticky');
        // $('.banner').removeClass('margin-top');
      }
    }
  });
};

exports.default = StickyHeader;

},{}],6:[function(require,module,exports){
'use strict';

var _stickyHeader = require('./modules/sticky-header.js');

var _stickyHeader2 = _interopRequireDefault(_stickyHeader);

var _modal = require('./modules/modal.js');

var _modal2 = _interopRequireDefault(_modal);

var _scrollTo = require('./modules/scroll-to.js');

var _scrollTo2 = _interopRequireDefault(_scrollTo);

var _mobileMenu = require('./modules/mobile-menu.js');

var _mobileMenu2 = _interopRequireDefault(_mobileMenu);

var _mask = require('./modules/mask.js');

var _mask2 = _interopRequireDefault(_mask);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import ParticlesJS           from './modules/particles.js';

// const inView         = new InView();

// import Accordion             from './modules/accordion.js';
var stickyHeader = new _stickyHeader2.default();
// const accordion      = new Accordion();

// import MenuIcons             from './modules/menu-icons.js';
// import VideoPlay             from './modules/video-play.js';
// import FilterPortfolio       from './modules/filter.js';
// import WPGallery             from './modules/wp-gallery.js';
// import InView                from './modules/in-view.js';
var modal = new _modal2.default();
var scrollTo = new _scrollTo2.default();
var mobileMenu = new _mobileMenu2.default();
// const menuIcons      = new MenuIcons();
// const videoPlay      = new VideoPlay();
// const filterPorfolio = new FilterPortfolio();
// const wpGallery      = new WPGallery();
var foneMask = new _mask2.default();
// const particlesjs    = new ParticlesJS();

},{"./modules/mask.js":1,"./modules/mobile-menu.js":2,"./modules/modal.js":3,"./modules/scroll-to.js":4,"./modules/sticky-header.js":5}]},{},[6]);
